module.exports = __webpack_public_path__ + "ab869890c2fc9984ca0cb6d74d13e1a5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/owl_hoots/horned_owl_hoot.png
// module id = 2889
// module chunks = 0